__webpack_require__.p = "/cv-in-new-tab-for-all-permissions/referrals/";